module.exports = __webpack_public_path__ + "static/fonts/NanumSquareR.4217b4c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareR.woff
// module id = 6V1e
// module chunks = 1